(() => {
  const tooltipGap = 14
  const viewportGap = 8
  let cursorTooltip

  const getCursorTooltip = () => {
    if (cursorTooltip) return cursorTooltip

    cursorTooltip = document.createElement('div')
    cursorTooltip.className = 'biky-cursor-tooltip'
    cursorTooltip.setAttribute('aria-hidden', 'true')
    document.body.appendChild(cursorTooltip)
    return cursorTooltip
  }

  const hideTooltip = () => {
    if (cursorTooltip) cursorTooltip.classList.remove('biky-cursor-tooltip--visible')
  }

  const placeTooltip = (benefit, clientX, clientY) => {
    const source = benefit.querySelector('.biky-card__benefit-tooltip')
    if (!source) return

    const tooltip = getCursorTooltip()
    tooltip.textContent = source.textContent
    tooltip.classList.add('biky-cursor-tooltip--visible')

    const tooltipRect = tooltip.getBoundingClientRect()
    let x = clientX + tooltipGap
    let y = clientY + tooltipGap

    if (x + tooltipRect.width > window.innerWidth - viewportGap) x = clientX - tooltipRect.width - tooltipGap
    if (y + tooltipRect.height > window.innerHeight - viewportGap) y = clientY - tooltipRect.height - tooltipGap

    tooltip.style.left = `${Math.max(viewportGap, x)}px`
    tooltip.style.top = `${Math.max(viewportGap, y)}px`
  }

  const bindBenefit = (benefit) => {
    if (benefit.dataset.bikyTooltipBound === 'true') return
    benefit.dataset.bikyTooltipBound = 'true'

    benefit.addEventListener('pointerenter', event => placeTooltip(benefit, event.clientX, event.clientY))
    benefit.addEventListener('pointermove', event => placeTooltip(benefit, event.clientX, event.clientY))
    benefit.addEventListener('pointerleave', hideTooltip)
    benefit.addEventListener('focus', () => {
      const rect = benefit.getBoundingClientRect()
      placeTooltip(benefit, rect.right, rect.top + rect.height / 2)
    })
    benefit.addEventListener('blur', hideTooltip)
    benefit.addEventListener('click', event => event.stopPropagation())
  }

  const init = root => root.querySelectorAll('.biky-card__benefit').forEach(bindBenefit)

  document.addEventListener('DOMContentLoaded', () => init(document))
  document.addEventListener('shopify:section:load', event => init(event.target))
})()
